module.exports = __webpack_public_path__ + "img/IMG_2614_T_L_Foamcore.2d41b304.jpg";